import React from "react"

const Text = props => {
  const { children, classes, as: Tag = 'p', color = "dark" } = props

  return <Tag className={`text${classes ? " " + classes : ""}`} data-color={color}>{children}</Tag>
}

export default Text
